import { render, staticRenderFns } from "./MotorBusClsList.vue?vue&type=template&id=c74d38b2&"
import script from "./MotorBusClsList.vue?vue&type=script&lang=js&"
export * from "./MotorBusClsList.vue?vue&type=script&lang=js&"
import style0 from "./MotorBusClsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorBusClsList.vue"
export default component.exports